import { useBreadcrumb } from "core/features/breadcrumbs";
import { Flex } from "@chakra-ui/react";
import HeaderTable from "components/Page/HeaderTable";
import {
  useAreaComumColumns,
  useAreasComum,
  useDeleteAreaComum,
} from "features/area-comum/hooks";
import { useCurrentTenant } from "features/auth/tenant.store";
import { useState } from "react";
import { AreaComumResponse } from "features/area-comum/typings";
import { showErrorAxios, showSuccess, showConfirm } from "infra/helpers/alerta";
import PageHeader from "components/Page/PageHeader";
import Filtros from "./components/Filtros";
import NewTable from "components/NewTable";
import history from "infra/helpers/history";
import { TabMenuOptions } from "../Detalhes/typings";
import ModalParametros from "./components/ModalParametros";
import OutlineButton from "components/Button/OutlineButton";
import Container from "components/Container";
import { useLoading } from "components/GlobalLoading";
import ModalHistoryAreaComum from "ui/pages/Admin/Cadastros/AreaComumPages/Listagem/components/ModalHistoryAreaComum";
import { BiCog } from "react-icons/bi";

function AreaComumListagemPage() {
  const [parametrosModalOpen, setParametrosModalOpen] = useState(false);
  const [modalLogsAreaComumId, setModalLogsAreaComumId] = useState<
    string | undefined
  >();
  const [page, setPage] = useState<number>(1);
  const [search, setSearch] = useState<string>("");

  const { tenant } = useCurrentTenant();

  const { isLoading, data, refetch, isFetching } = useAreasComum(tenant.id, {
    search,
    page,
  });
  const { isLoading: isLoadingDelete, mutate: handleDelete } =
    useDeleteAreaComum(tenant.id);

  const columns = useAreaComumColumns({
    onToogled: () => {
      refetch();
    },
  });

  useLoading(isLoadingDelete);

  useBreadcrumb([{ name: "Cadastros" }, { name: "Áreas comuns" }]);

  return (
    <Container>
      {parametrosModalOpen ? (
        <ModalParametros
          open={parametrosModalOpen}
          onClose={() => setParametrosModalOpen(false)}
        />
      ) : null}

      {modalLogsAreaComumId ? (
        <ModalHistoryAreaComum
          areaComumId={modalLogsAreaComumId}
          isOpenModal={!!modalLogsAreaComumId}
          onClose={() => setModalLogsAreaComumId(undefined)}
        />
      ) : null}

      <PageHeader
        onClick={() => history.push("/cadastros/areas-comum/new")}
        title="Áreas comuns"
        titleButton="Adicionar área comum"
        extraButtonTitle="Parâmetros"
        iconExtraButton={<BiCog />}
        extraButtonIconPosition="left"
        extraButtonOnClick={() => setParametrosModalOpen(true)}
      />

      <Filtros />

      <NewTable<AreaComumResponse>
        title={() => (
          <Flex alignItems="center">
            <HeaderTable
              value={search}
              onSearch={(q?: string) => setSearch(q!)}
            />

            <OutlineButton
              ml={4}
              fontSize={14}
              h="30px"
              onClick={() => history.push("/cadastros/areas-comum/bloqueio")}
            >
              Bloquear unidades
            </OutlineButton>
          </Flex>
        )}
        loading={isLoading || isFetching}
        columns={columns}
        dataSource={data?.items ?? []}
        customPagination={{
          currentPage: data?.meta.currentPage ?? 0,
          totalItems: data?.meta.totalItems ?? 0,
          itemsPerPage: data?.meta.itemsPerPage ?? 0,
          onChangePage: (p) => setPage(p),
        }}
        actions={[
          ...TabMenuOptions.map((option) => ({
            title: option.label,
            onClick: (v: AreaComumResponse) => {
              history.push(
                `/cadastros/areas-comum/${v.id}?opcao=${option.route}`
              );
            },
            permission: option.permission,
          })),
          {
            title: "Ver histórico",
            onClick: async (v) => {
              setModalLogsAreaComumId(v.id);
            },
          },
          {
            title: "Excluir",
            onClick: async (v) => {
              const { isConfirmed } = await showConfirm();

              if (isConfirmed) {
                handleDelete(v.id, {
                  onSuccess: () => showSuccess().then(() => refetch()),
                  onError: (err) => {
                    showErrorAxios(err);
                  },
                });
              }
            },
          },
        ]}
      />
    </Container>
  );
}

export default AreaComumListagemPage;
